import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import React from 'react'

function LoadingMultiRoomGroupHeaderSkeleton() {
  return (
    <Group direction="vertical" gap={2}>
      <TextLoadingBox typography="heading6" lines={1} width="30ch" />
      <TextLoadingBox typography="body-medium" lines={1} width="20ch" />
      <TextLoadingBox typography="body-medium" lines={1} width="20ch" />
    </Group>
  )
}

export default LoadingMultiRoomGroupHeaderSkeleton
